import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const RevealSection = ({ children, delay = 0, className = "" }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-80px" });
  
    return (
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 24 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.7, delay, ease: "easeOut" }}
        className={className}
      >
        {children}
      </motion.div>
    );
  };

  export default RevealSection;